import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function cleanPhoneNumber(value) {
  return String(value || '')
    .replace(/undefined/g, '')
    .replace(/&(?:nbsp|#0*32|#0*160|#x0*20|#x0*a0);/gi, ' ')
    .replace(/\u00a0/g, ' ')
    .trim();
}

export function normalizePhoneNumber(value) {
  let raw = cleanPhoneNumber(value);
  if (!raw) return '';
  if (validatePhoneNumber(raw)) return raw;

  raw = raw.replace(/\(0\)/g, '');
  const hasPlus = raw.trim().startsWith('+');
  if (raw.trim().startsWith('00')) {
    raw = `+${raw.trim().slice(2)}`;
  }

  const digits = raw.replace(/\D/g, '');
  if (!digits) return '';

  if (hasPlus || raw.trim().startsWith('+')) {
    if (digits.startsWith('49')) return formatGermanPhoneNumber(digits.slice(2));
    return `+${digits}`;
  }
  if (digits.startsWith('0049')) return formatGermanPhoneNumber(digits.slice(4));
  if (digits.startsWith('49') && digits.length > 10) return formatGermanPhoneNumber(digits.slice(2));
  if (digits.startsWith('0')) return formatGermanPhoneNumber(digits.replace(/^0+/, ''));
  return formatGermanPhoneNumber(digits);
}

export function validatePhoneNumber(value) {
  const raw = cleanPhoneNumber(value);
  if (!raw) return '';
  if (/[A-Za-zÄÖÜäöüß]/.test(raw)) return 'Telefonnummer darf keine Buchstaben enthalten';
  if (/[^0-9+\s()/.-]/.test(raw)) return 'Telefonnummer enthält ungültige Zeichen';
  const digits = raw.replace(/\D/g, '');
  if (digits.length < 7) return 'Telefonnummer ist zu kurz';
  if (digits.length > 16) return 'Telefonnummer ist zu lang';
  const plusCount = (raw.match(/\+/g) || []).length;
  if (plusCount > 1 || (plusCount === 1 && !raw.trim().startsWith('+'))) return 'Pluszeichen ist nur am Anfang erlaubt';
  return '';
}

function formatGermanPhoneNumber(nationalValue) {
  const national = String(nationalValue || '').replace(/^0+/, '');
  if (!national) return '';
  let prefixLength;
  if (/^(15|16|17)/.test(national)) {
    prefixLength = national.startsWith('15') && national.length > 10 ? 4 : 3;
  } else if (/^(30|40|69|89)/.test(national)) {
    prefixLength = 2;
  } else if (/^(221|228|231|234|351|421|511|711|911)/.test(national)) {
    prefixLength = 3;
  } else {
    prefixLength = Math.min(4, Math.max(2, national.length - 7));
  }
  return `+49 ${national.slice(0, prefixLength)} ${national.slice(prefixLength)}`.trim();
}
